import React, { Component } from 'react';  
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';

import s from './Values.css';
import cs from '../../commonStyle.css';
import cx from 'classnames';
import messages from '../../../locale/messages';

import safety_img from '/images/safety.jpg';
import community_img from '/images/community.jpg';
import innovation_img from '/images/innovation.jpg';

class Values extends Component {
  render() {
    const { values } = this.props;
    return (
      <>
      <div className={cx(s.values)}>
        <div className={cx(s.container)}>
          <h3 className={cx(s.title, s.iconTitleSecond)}>
            <FormattedMessage {...messages.ourValues} />
          </h3>
          <div className={cx(s.valuesList, s.space)}>
            {values && values.map((item) => (
              <div className={cx(s.valuesItem)} key={item.id}>
                <div className={cx(s.valuesImage)}>
                  <img src={item.image_url} alt={item.title} />
                </div>
                <div className={cx(s.valuesContent)}>
                  <h4>{item.title}</h4>
                  <p>{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
  }
}

export default withStyles(s, cs)(Values);